export default "__VITE_ASSET__BFu4oqzB__"